import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-mic-off",
  templateUrl: "./med-icon-mic-off.component.html",
})
export class MedIconMicOffComponent extends SvgMixinComponent {}
